import { render, staticRenderFns } from "./modalUscis.vue?vue&type=template&id=279cd930"
import script from "./modalUscis.vue?vue&type=script&lang=js"
export * from "./modalUscis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports